import { render, staticRenderFns } from "./FooterAreas.vue?vue&type=template&id=5ecf36b1"
import script from "./FooterAreas.vue?vue&type=script&lang=js"
export * from "./FooterAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports